import { sidebarItemsLimitationCount } from '@@ting/utils/constants/common'

export const sliceArray = (list: any[] = [], viewAll = false, sliceNumber = sidebarItemsLimitationCount): any[] =>
  viewAll ? list : list.slice(0, sliceNumber)
